const Mn = require('backbone.marionette');
const ProjectStatusCollectionFactory = require('common/domain/factory/project-status/collection');
const ProjectListView = require('balus/ui/view/body/group/nav/project-list');
const NavWidthChanger = require('balus/ui/view/nav-width-changer');
const Template = require('balus/ui/template/body/group/nav/index.hbs');

module.exports = Mn.View.extend({
    template: Template,
    regions: {
        activeProjectList: '.active-project-list-wrapper',
        inactiveProjectList: '.inactive-project-list-wrapper',
        widthChanger: '#nav-width-changer-wrapper'
    },
    ui: {
        inactiveProjectTab: '.inactive-project-tab'
    },

    onRender: function() {
        this.showChildView('widthChanger', new NavWidthChanger());
        const group = this.model;

        const activeProjectCollection = ProjectStatusCollectionFactory
            .find(group)
            .getActiveProjectStatusCollection();
        activeProjectCollection
            .fetchFirstPage()
            .then(() => {
                this.showChildView('activeProjectList', new ProjectListView({
                    model: this.model,
                    collection: activeProjectCollection,
                    context: this.getOption('context')
                }));
            });

        const inactiveProjectCollection = ProjectStatusCollectionFactory
            .find(group)
            .getInactiveProjectStatusCollection();
        this.ui.inactiveProjectTab.on('show.bs.tab', () => {
            inactiveProjectCollection
                .fetchFirstPage()
                .then(() => {
                    this.showChildView('inactiveProjectList', new ProjectListView({
                        model: this.model,
                        collection: inactiveProjectCollection,
                        context: this.getOption('context')
                    }));
                });
        });
    }
});



// WEBPACK FOOTER //
// ./balus/ui/view/body/group/nav/index.js